export default [
  {
    path: '/admin/customer-profiles',
    name: 'customer-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/profile/index.vue')
  },
  {
    path: '/admin/customer-profiles/create',
    name: 'customer-profile-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/profile/create.vue')
  },
  {
    path: '/admin/customer-profiles/:id/edit',
    name: 'customer-profile-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/profile/edit.vue')
  }
]
